import { MissionSpecCard, MissionSpecCardRole } from "models/MissionSpec";
import { MissionRoleStatus } from "@a_team/models/dist/MissionRole";
import { MissionStatus } from "@a_team/models/dist/MissionObject";
import { pluralizeString } from "helpers/strings";

const EMPTY_STRING = "";

export const countOpenRoles = (roles: MissionSpecCardRole[] = []) => {
  return (
    roles?.filter((role) =>
      [MissionRoleStatus.Open, undefined].includes(role.status)
    ).length ?? 0
  );
};

export const countActiveRoles = (roles: MissionSpecCardRole[] = []) => {
  return (
    roles?.filter((role) =>
      [MissionRoleStatus.Active, MissionRoleStatus.ScheduledToEnd].includes(
        role.status
      )
    ).length ?? 0
  );
};

export const humanReadableStatus = (
  specStatus: string = EMPTY_STRING,
  platformStatus: MissionStatus = EMPTY_STRING as MissionStatus,
  hasProposals: boolean = false,
  openRolesCount: number = 0,
  startAProject?: boolean
): string | undefined => {
  if (startAProject) {
    return "Start a project";
  }

  // Mission Statuses
  if (specStatus === "published") {
    if (hasProposals) {
      return "Your team is ready";
    }

    if (
      [MissionStatus.Archived, MissionStatus.Ended].includes(platformStatus)
    ) {
      return "Closed";
    }

    if (platformStatus === MissionStatus.ScheduledToEnd) {
      return "Ending soon";
    }

    if (platformStatus !== MissionStatus.Running) {
      return "Curating your team";
    }

    if (openRolesCount > 0) {
      return pluralizeString(openRolesCount, "open role", "open roles");
    }

    return;
  }

  // Spec Statuses
  if (specStatus === "formation") {
    return "Pending approval";
  }

  return "Draft";
};

export const sortMissions = (a: MissionSpecCard, b: MissionSpecCard) =>
  new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
